import React, { useEffect, useRef, useState } from "react";
import {
  clearIntervalAsync,
  setIntervalAsync,
} from "set-interval-async/dynamic";
import { getZonedTime, timeToDate, tsToDate } from "../../helpers/date.helper";
import { connectRacingPage } from "./RacingPage.connect";
import SportMarketStandard from "../../components/SportMarketStandard/SportMarketStandard";
import "./RacingPage.scss";
import UpcomingRacesAccordion from "../../components/UpcomingRacesAccordion/UpcomingRacesAccordion";
import httpAuth from "../../services/httpAuth";
import { GET_MARKET_DATA_INTERVAL } from "../../config/app.config";
import httpNotAuth from "../../services/httpNotAuth";
import { joidTigari } from "../../helpers/joditigari.helper";
import TabView from "../../components/TabView/TabView";
import { useLocation } from "react-router-dom";
// import getErrorMessage from '../../helpers/getErrorMessage.helper'
// import { requestRacingPageData } from '../../store/racingPage/racingPage.thunks'
// import { useSelector } from 'react-redux'
// import {useHistory} from "react-router";

const RacingPage = ({
  timeSettings,
  navigationHeaderMenu,
  betPlacing,
  menu,
  auth,
  actions,
  racingPage,
  hrEventId,
  hrMarketId,
  hrCountryCode,
}) => {
  const location = useLocation();
  //states
  const [isDetail, setIsDetail] = useState(false);
  const [raceOdds, setRaceOdds] = useState(null);
  const [isAccordionOpen, setIsAccordionOpen] = useState(1);
  const [allRunnerSuspend, setAllRunnerSuspend] = useState(false);
  const [eventID, setEventId] = useState(null);
  const [oddId, setOddId] = useState(null);
  const [selectedRaces, setSelectedRaces] = useState([]);
  const [combinedMarket, setCombinedMarket] = useState(null);
  const headerRef = useRef(null);

  const [selectedTab, setSelectedTab] = useState("InPlay");
  const inplayTabRef = useRef(null);
  const competitionRef = useRef(null);

  const width = window.innerWidth;

  //end states

  useEffect(() => {
    if (selectedRaces.length <= 1) {
      setCombinedMarket(null);
    } else {
      let horseData = joidTigari(selectedRaces);
      setCombinedMarket(horseData);
    }
  }, [selectedRaces]);

  useEffect(() => {
    if (!auth) {
      if (hrEventId && hrMarketId) {
        raceDataRequestNoAuth(hrEventId, hrMarketId);
      }
    } else {
      if (hrEventId && hrMarketId) {
        raceDataRequest(hrEventId, hrMarketId);
        actions.requestSportStart(hrMarketId, true);
      }
    }
  }, [racingPage, auth, hrEventId, hrMarketId]);

  useEffect(() => {
    if (!auth) {
      const mainTimer = setIntervalAsync(async () => {
        if (hrEventId && hrMarketId) {
          raceDataRequestNoAuth(hrEventId, hrMarketId);
        }
      }, 15000);
      return () => clearIntervalAsync(mainTimer);
    } else {
      const mainTimer = setIntervalAsync(
        async () => {
          if (hrEventId && hrMarketId) {
            raceDataRequest(hrEventId, hrMarketId);
          }
        },
        GET_MARKET_DATA_INTERVAL,
        hrEventId,
        hrMarketId
      );

      return () => clearIntervalAsync(mainTimer);
    }
  }, [racingPage, auth, hrEventId, hrMarketId]);

  useEffect(() => {
    if (auth) {
      const mainTimer = setIntervalAsync(async () => {
        if (hrEventId && hrMarketId) {
          actions.requestSportStart(hrMarketId, true);
        }
      }, 30000);
      return () => clearIntervalAsync(mainTimer);
    }
  }, [racingPage, auth, hrEventId, hrMarketId]);

  // get all suspend
  useEffect(() => {
    if (
      raceOdds?.runners?.filter((runner) => runner.status !== "SUSPENDED")
        .length >= 1
    ) {
      setAllRunnerSuspend(false);
    } else {
      setAllRunnerSuspend(true);
    }
  }, [raceOdds]);
  // end get all suspend

  // request api
  const raceDataRequestNoAuth = async (event, market) => {
    const data = {
      market_id: market,
      match_id: event,
    };
    try {
      const response = await httpNotAuth.post(`match/matchDetailsOpen`, data);
      if (response.data.status) {
        setRaceOdds(response?.data?.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const raceDataRequest = async (event, market) => {
    const data = {
      market_id: market,
      match_id: event,
      combine: true,
    };
    try {
      const response = await httpAuth.post(`match/matchDetails`, data);
      if (response.data.status) {
        setRaceOdds(response?.data?.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const formatDateTime = (dateTime) => {
    const targetDate = new Date(dateTime);

    // Get components
    const hours = targetDate.getHours();
    const minutes = targetDate.getMinutes();
    const day = targetDate.getDate();
    const month = targetDate.getMonth() + 1; // Months are 0-based
    const year = targetDate.getFullYear();

    // Format hours and minutes
    const formattedMinutes = minutes.toString().padStart(2, "0");
    const period = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 === 0 ? 12 : hours % 12;

    // Construct formatted date and time
    return `${formattedHours}:${formattedMinutes} ${period}, ${day
      .toString()
      .padStart(2, "0")}-${month.toString().padStart(2, "0")}-${year}`;
  };

  useEffect(() => {
    if (
      auth &&
      (location.pathname.includes("horse-racing") ||
        location.pathname.includes("greyhound-racing"))
    ) {
      const racingData = {
        sport_id: location.pathname.includes("horse-racing") ? "7" : "4339",
      };

      getMenu(racingData);

      const mainTimer = setIntervalAsync(async () => {
        const racingData = {
          sport_id: location.pathname.includes("horse-racing") ? "7" : "4339",
        };

        getMenu(racingData);
      }, 60000);
      return () => clearIntervalAsync(mainTimer);
    }
  }, [auth, selectedTab, location]);

  const getMenu = (data) => {
    actions
      .requestRacingPageData(data)
      .catch((e) => console.log("menu error = ", e));
  };

  // useEffect(() => {
  //   console.log('my response try useffect')
  //   actions.requestRacingPageData(navigationHeaderMenu.navigationID).then((response) => console.log('??response', response))
  // }, [navigationHeaderMenu.navigationID])
  // end request api

  // save page id if page refreshed
  useEffect(() => {
    if (navigationHeaderMenu.navigationID) {
      sessionStorage.setItem("navigationID", navigationHeaderMenu.navigationID);
    }
    if (navigationHeaderMenu.navigationName) {
      sessionStorage.setItem(
        "navigationName",
        navigationHeaderMenu.navigationName
      );
    }
    headerRef.current.scrollIntoView({
      block: "start",
      behavior: "smooth",
    });
  }, [navigationHeaderMenu.navigationID]);

  const Tabs = [
    {
      ref: inplayTabRef,
      name: "In Play",
      onClick: () => setSelectedTab("InPlay"),
    },
    {
      ref: competitionRef,
      name: "Upcoming",
      onClick: () => setSelectedTab("Upcoming"),
    },
  ];

  let flag = hrCountryCode?.toLowerCase();

  // useEffect(() => {
  // }, [navigationHeaderId, navigationName])
  // end save page id if page refreshed

  // console.log('raceOdds ??!!', raceOdds)
  // console.log('Date.parse(raceOdds?.start) ??!!', Date.parse(1645701420000))

  return (
    <div
      className="race-page w-full md:mt-[0px] lg:overflow-auto lg:w-[54%]"
      style={{ position: "relative" }}
    >
      <span
        style={{ position: "absolute", top: "-135px" }}
        ref={headerRef}
      ></span>

      <div className="px-2 w-full lg:hidden">
        <TabView myTabs={Tabs} selectedTab={selectedTab == "InPlay" ? 0 : 1} />
      </div>

      {width < 1024 && racingPage && (
        <>
          <div className="race-page__content mt-[15px] ">
            {racingPage
              .filter((item) =>
                selectedTab == "InPlay" ? item?.inplay : !item?.inplay
              )
              .map((item, index) => {
                return (
                  <UpcomingRacesAccordion
                    key={item?.match_id + index}
                    item={item}
                    index={index}
                    isAccordionOpen={isAccordionOpen}
                    setIsAccordionOpen={setIsAccordionOpen}
                    showHeader={false}
                    showJockeyName={true}
                  />
                );
              })}
          </div>
        </>
      )}

      {racingPage && racingPage.length > 0 ? (
        <>
          {width >= 1024 && (
            <div className="race-page__content">
              <div
                className={`race-page__content-rase-odds-table-wrapper ${
                  allRunnerSuspend === true ? "all-suspended" : ""
                }`}
              >
                <div className="race-page__content-header">
                  <div
                    className={`${
                      raceOdds?.inplay === false ? "not-in-play" : "in-play"
                    } race-page__content-header-next-race`}
                  >
                    <span className="col-span-6 text-base font-bold  flex items-center justify-start gap-x-1">
                      <span className="f32">
                        <div className={`flag ${flag}`}></div>
                      </span>
                      <span>{raceOdds?.match_name}</span>
                    </span>
                    <span>
                      {formatDateTime(
                        getZonedTime(
                          timeSettings?.timeZoneName,
                          raceOdds?.match_date
                        )
                      )}
                      &nbsp;
                    </span>
                    {/*<span>{(tsToDate(Date.parse(raceOdds?.start), timeSettings?.timeZoneName).split(" ")[1]).split(":", 2).join(":") }&nbsp;</span>*/}
                    {/* <span> */}
                    {/* {raceOdds?.match_name} */}
                    {/* {tsToDate(
                    Date.parse(raceOdds?.market_start_time),
                    timeSettings?.timeZoneName
                  )
                    .split(" ")[1]
                    .split(":", 2)
                    .join(":")}
                  &nbsp; */}
                    {/* </span> */}
                    {/* <span>{raceOdds?.name.replace("${HH:mm}", "")}</span> */}
                  </div>
                  {/* <span className="race-page__header-subtitle">Opens in</span> */}
                </div>
                {combinedMarket && (
                  <div>
                    <div className="race-page__content-rase-odds-table-header">
                      <p>Combined Market</p>
                      <div>
                        <span>Back</span>
                        <span>Lay</span>
                      </div>
                    </div>
                    <div
                      className={`${
                        combinedMarket?.isBettable === false ? "unbettable" : ""
                      } race-page__content-rase-odds-table`}
                    >
                      {allRunnerSuspend === true && (
                        <div className="race-page__content-all-suspend-cover">
                          <span>SUSPENDED</span>
                        </div>
                      )}
                      {combinedMarket && (
                        <SportMarketStandard
                          data={combinedMarket}
                          key={combinedMarket?.market_id}
                          betPlacing={betPlacing}
                          showHeader={false}
                          showJockeyName={true}
                          isRacing={true}
                        />
                      )}
                    </div>
                  </div>
                )}
                <div>
                  {/* <div className="race-page__content-rase-odds-table-header">
                <p>Race Odds</p>
                <div>
                  <span>Back</span>
                  <span>Lay</span>
                </div>
              </div> */}
                  <div
                    className={`${
                      raceOdds?.isBettable === false ? "unbettable" : ""
                    } race-page__content-rase-odds-table`}
                  >
                    {/* {allRunnerSuspend === true && (
                  <div className="race-page__content-all-suspend-cover">
                    <span>SUSPENDED</span>
                  </div>
                )} */}
                    {raceOdds && (
                      <SportMarketStandard
                        data={raceOdds}
                        key={raceOdds?.market_id}
                        betPlacing={betPlacing}
                        showHeader={false}
                        showJockeyName={true}
                        isRacing={true}
                        selectedRaces={selectedRaces}
                        setSelectedRaces={setSelectedRaces}
                      />
                    )}
                  </div>
                </div>
              </div>
              {/* <div
            className={`race-page__content-upcoming-races-table-wrapper ${
              allRunnerSuspend === true ? "all-suspended" : ""
            }`}
          >
            <div className="race-page__content-header">
              <span className="race-page__content-header-next-race">
                Upcoming Races
              </span>
            </div>
            <div className="race-page__content-upcoming-races-table">
              <div>
                {racingPage &&
                  racingPage.map((item, index) => {
                    return (
                      <UpcomingRacesAccordion
                        key={item?.market_id + index}
                        item={item}
                        index={index}
                        isAccordionOpen={isAccordionOpen}
                        setIsAccordionOpen={setIsAccordionOpen}
                        showHeader={false}
                        showJockeyName={true}
                      />
                    );
                    // const slicedItem = {...item, runners: item?.runners?.slice(0, 3)}
                    // let flag = slicedItem?.country_code?.toLowerCase()

                    // const setEvent = (item) => {
                    //   setIsAccordionOpen(item?.market_id)
                    //   setEventId(item?.match_id)
                    //   let eventId = item?.match_id;
                    //   let oddId = item?.market_id;
                    //   actions.requestRaceOdds(eventId, oddId)
                    // }

                    // return (
                    //   <div key={slicedItem?.market_id + index} className="race-page__content-upcoming-races-table-row">
                    //     <div className="race-page__content-upcoming-races-table-row-header f32"
                    //       onClick={() => isAccordionOpen === slicedItem?.market_id ? setIsAccordionOpen(null) : setEvent(slicedItem)}
                    //     >
                    //       <div className={`flag ${flag}`}></div>
                    //       <div className="race-page__content-upcoming-races-table-row-header-text">
                    //         <span>{slicedItem?.name.replace("${HH:mm}","")}</span>
                    //         <span>{(tsToDate(Date.parse(slicedItem?.market_start_time), timeSettings?.timeZoneName).split(" ")[1]).split(":", 2).join(":") }</span>
                    //       </div>
                    //       <div className="race-page__content-upcoming-races-table-row-header-arrowContainer">
                    //         <span className={`race-page__content-upcoming-races-table-row-header-arrow ${isAccordionOpen === slicedItem?.market_id ? "active" : ""}`}></span>
                    //       </div>
                    //     </div>
                    //       <div className={`race-page__content-upcoming-races-table-row-inner ${isAccordionOpen === slicedItem?.market_id ? "open" : ""}`}>
                    //         <div className="race-page__content-rase-odds-table-header">
                    //           <p>Top 3 of {raceOdds && raceOdds[`${eventID} ${isAccordionOpen}`]?.runners?.length} runners</p>
                    //           <div>
                    //             <span>Back</span>
                    //             <span>Lay</span>
                    //           </div>
                    //         </div>
                    //         <div className="race-page__content-upcoming-races-table-row-items-wrapper">
                    //           {allRunnerSuspend === true && <div className="race-page__content-all-suspend-cover"><span>SUSPENDED</span></div>}
                    //           {<SportMarketStandard data={raceOdds ? raceOdds[`${eventID} ${isAccordionOpen}`] : []} key={slicedItem?.market_id} betPlacing={betPlacing} showHeader={false} showJockeyName={true} />}
                    //         </div>
                    //       </div>
                    //   </div>
                    // )
                  })}
              </div>
            </div>
          </div> */}
            </div>
          )}
        </>
      ) : (
        <>
          <div className="sportsPage-subHeader text-white">
            <span>There are currently no upcoming events.</span>
          </div>
        </>
      )}

      <div
        className={`w-full mt-5 px-2 ${isDetail && "pb-10"} flex flex-col gap-4`}
        // style={{ backgroundColor: "#fff" }}
      >
        <article className="bg-bg_color_primary rounded-md font-lato ">
          <div
            className="w-full flex items-center justify-center text-text_color_primary1"
            onClick={() => setIsDetail(!isDetail)}
          >
            <h1 className="text-sm sm:text-base p-3 font-bold w-full flex items-center justify-between rounded-sm cursor-pointer">
              <span className="font-lato text-[14px]">
                {location.pathname.includes("horse-racing")
                  ? "Horse"
                  : "Greyhound"}{" "}
                Racing Betting |{" "}
                {window.location.hostname
                  .replace("www.", "")
                  .split(".")[0]
                  .toUpperCase()}
              </span>

              <svg
                fill=""
                width="16"
                height="16"
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 330 330"
                className={`w-4 transition-all duration-300 ease-in-out h-4 ${
                  isDetail && "-rotate-180"
                }`}
              >
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    id="XMLID_225_"
                    d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393 c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393 s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"
                  ></path>
                </g>
              </svg>
            </h1>
          </div>
          {isDetail && (
            <>
              <h1 className="hidden">
                {location.pathname.includes("horse-racing")
                  ? "Horse"
                  : "Greyhound"}{" "}
                Racing Betting |{" "}
                {window.location.hostname
                  .replace("www.", "")
                  .split(".")[0]
                  .toUpperCase()}
              </h1>
              <h2 className="hidden">
                Bet on{" "}
                {location.pathname.includes("horse-racing")
                  ? "horse"
                  : "greyhound"}{" "}
                racing with{" "}
                {window.location.hostname
                  .replace("www.", "")
                  .split(".")[0]
                  .toUpperCase()}
                . Enjoy competitive betting odds, fast payouts, and an exciting
                experience on every race.
              </h2>
              <article
                className="w-full py-2 border-t text-text_color_primary1  scroll-smooth transition-all duration-300 ease-in-out border-t-border_color_primary px-2  overflow-y-auto"
                style={{ height: "max-content", maxHeight: "50vh" }}
              >
                <h2>
                  Learn How to Bet on{" "}
                  {location.pathname.includes("horse-racing")
                    ? "Horse"
                    : "Greyhound"}{" "}
                  Racing Online
                </h2>
                <h2>&nbsp;</h2>
                <p>
                  People have been drawn to{" "}
                  {location.pathname.includes("horse-racing")
                    ? "horse"
                    : "greyhound"}{" "}
                  racing for decades because it is such an exciting sport. Fans
                  of these quick dogs have been to the tracks and, more
                  recently, internet platforms to watch them race to the finish
                  line. These steps will help you understand how to start
                  betting on{" "}
                  {location.pathname.includes("horse-racing")
                    ? "horse"
                    : "greyhound"}{" "}
                  races online on sites like{" "}
                  {window.location.hostname
                    .replace("www.", "")
                    .split(".")[0]
                    .toUpperCase()}{" "}
                  if you're new to the world of{" "}
                  <a target="_blank" rel="noopener noreferrer" href="/">
                    <u>online betting</u>
                  </a>{" "}
                  on these exciting events.
                </p>
                <p>&nbsp;</p>
                <h2>
                  What is{" "}
                  {location.pathname.includes("horse-racing")
                    ? "Horse"
                    : "Greyhound"}{" "}
                  Racing Betting?
                </h2>
                <h2>&nbsp;</h2>
                <p>
                  {location.pathname.includes("horse-racing")
                    ? "Horse"
                    : "Greyhound"}{" "}
                  racing betting online involves betting on the dogs that are
                  running in races and guessing which dog will win or finish in
                  the top three. Like horse racing, there are different ways to
                  bet on{" "}
                  {location.pathname.includes("horse-racing")
                    ? "horse"
                    : "greyhound"}{" "}
                  races, and each one usually comes with a different level of
                  risk and profit. Thanks to progress in technology, online
                  gaming platforms have made it possible for anyone to quickly
                  play this exciting sport from home.
                </p>
                <p>&nbsp;</p>
                <h2>
                  Why Bet on{" "}
                  {location.pathname.includes("horse-racing")
                    ? "Horse"
                    : "Greyhound"}{" "}
                  Racing Online?
                </h2>
                <h2>&nbsp;</h2>
                <p>
                  There are several good things about{" "}
                  {location.pathname.includes("horse-racing")
                    ? "horse"
                    : "greyhound"}{" "}
                  race betting online. First, it's very handily done. You do not
                  need to visit a dog betting site physically to place a bet.
                  You can do it from any part of the world and at any time.
                  Making it even more exciting, you can now wager on the
                  majority of various games on websites like{" "}
                  {window.location.hostname
                    .replace("www.", "")
                    .split(".")[0]
                    .toUpperCase()}
                  , so rest assured there's never a dull moment. Typically,
                  online sportsbooks provide helpful resources such as data,
                  tips, and live streams to help you make wise decisions.
                </p>
                <p>&nbsp;</p>
                <h2>
                  How to Get Started with{" "}
                  {location.pathname.includes("horse-racing")
                    ? "Horse"
                    : "Greyhound"}{" "}
                  Racing Betting Online
                </h2>
                <h2>&nbsp;</h2>
                <h4>
                  Choose a trustworthy{" "}
                  {location.pathname.includes("horse-racing")
                    ? "Horse"
                    : "Greyhound"}{" "}
                  betting site
                </h4>
                <p>
                  Choosing an online site for{" "}
                  {location.pathname.includes("horse-racing")
                    ? "horse"
                    : "greyhound"}{" "}
                  races is always a first step in order to start gambling. Look
                  for a site with a good reputation and that offers safety with
                  a large variety of different games available. Of course,
                  {window.location.hostname
                    .replace("www.", "")
                    .split(".")[0]
                    .toUpperCase()}{" "}
                  is the best out of them since its structure is crystal clear,
                  with brilliant customer service.
                </p>
                <p>&nbsp;</p>
                <h4>Sign Up and Fund Your Account</h4>
                <p>
                  Provide your information and sign up. After signing up, you
                  will need to top up your account. You can pay at Unicorn365
                  with a lot of different methods, such as credit cards,
                  e-wallets, bank transfers, and more. It also has benefits for
                  new users, so don't miss out!
                </p>
                <p>&nbsp;</p>
                <h4>Know the Different Kinds of Bets</h4>
                <p>
                  You should know about the following types of bets before you
                  place your first one:
                </p>
                <p>
                  <br />
                  1: Win Bet: You bet that a certain dog will win the race.
                  <br />
                  2: Place Bet: This is when you bet that a dog will come in
                  first or second.
                  <br />
                  3: Show Bet: You bet that a dog will finish in the first three
                  spots.
                  <br />
                  4: If you get it right, you correctly guess the first and
                  second place dogs.
                  <br />
                  5: There are two dogs that you bet will finish in the top two,
                  in any order.
                  <br />
                  &nbsp;
                </p>
                <p>
                  There are different chances and possible payouts for each type
                  of bet, so pick the one that suits you best.
                </p>
                <p>&nbsp;</p>
                <h4>Look at the races and dogs</h4>
                <p>
                  Knowledge is power when placing your bet on{" "}
                  {location.pathname.includes("horse-racing")
                    ? "Horse"
                    : "Greyhound"}{" "}
                  races online. Do some in-depth studying on how dogs finished
                  in the past, the track surface embracing—all that'. Most, if
                  not all, dog betting sites, which include{" "}
                  {window.location.hostname
                    .replace("www.", "")
                    .split(".")[0]
                    .toUpperCase()}
                  , come loaded with tools to let you perform all necessary
                  research and statistics for smart bets.
                </p>
                <p>&nbsp;</p>
                <h4>Place Your Bet</h4>
                <p>
                  This is now that you have done your research and selected your
                  bet that you place your bet. You simply select the race, dog,
                  and amount to be bet on. With that, you now just have to wait
                  for the races to start.
                </p>
                <p>&nbsp;</p>
                <h4>Watch the race and get your prizes</h4>
                <p>
                  And you will be able to watch the race live via the
                  application after you bet. Your account will automatically add
                  the winnings in case you win a bet with this application. It
                  is very simple to get your wins from{" "}
                  {window.location.hostname
                    .replace("www.", "")
                    .split(".")[0]
                    .toUpperCase()}{" "}
                  any time you want.
                </p>
                <p>&nbsp;</p>
                <h2>
                  Popular Games on{" "}
                  {window.location.hostname
                    .replace("www.", "")
                    .split(".")[0]
                    .toUpperCase()}
                </h2>
                <p>
                  Having loads of fun while you bet online at{" "}
                  {window.location.hostname
                    .replace("www.", "")
                    .split(".")[0]
                    .toUpperCase()}{" "}
                  for the
                  {location.pathname.includes("horse-racing")
                    ? "Horse"
                    : "Greyhound"}{" "}
                  races is just one of the myriads of other games that you
                  should be trying your hand at. You can improve your betting
                  experience and the number of ways you can bet in these famous
                  ways:
                </p>
                <p>&nbsp;</p>
                <p>
                  <a target="_blank" rel="noopener noreferrer" href="/">
                    <u>Aviator Game</u>
                  </a>{" "}
                  is a betting game where you guess how high an aeroplane will
                  fly before it takes off.
                </p>
                <p>
                  You can bet on something different in{" "}
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="/horse-racing"
                  >
                    <u>horse racing</u>
                  </a>
                  , which is another famous game.
                </p>
                <p>
                  <a target="_blank" rel="noopener noreferrer" href="/">
                    <u>Indian Card Games</u>
                  </a>
                  : This group includes many well-known games, such as Rummy and
                  Teen Patti.
                </p>
                <p>
                  <a target="_blank" rel="noopener noreferrer" href="/">
                    <u>Casino Games</u>
                  </a>
                  : You can play{" "}
                  <a target="_blank" rel="noopener noreferrer" href="/">
                    <u>poker</u>
                  </a>
                  ,{" "}
                  <a target="_blank" rel="noopener noreferrer" href="/">
                    <u>blackjack</u>
                  </a>
                  , and{" "}
                  <a target="_blank" rel="noopener noreferrer" href="/">
                    <u>roulette</u>
                  </a>{" "}
                  at{" "}
                  {window.location.hostname
                    .replace("www.", "")
                    .split(".")[0]
                    .toUpperCase()}
                  . These are all basic casino games.
                </p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <h2>
                  FAQs about{" "}
                  {location.pathname.includes("horse-racing")
                    ? "Horse"
                    : "Greyhound"}{" "}
                  Racing Betting
                </h2>
                <h2>&nbsp;</h2>
                <h3>
                  Question: How do I choose the best{" "}
                  {location.pathname.includes("horse-racing")
                    ? "Horse"
                    : "Greyhound"}{" "}
                  Racing betting site?
                </h3>
                <p>
                  Answer: Find a site that is safe, has a good name, and lets
                  you bet on and race on the things you want to bet on. In this
                  field,{" "}
                  {window.location.hostname
                    .replace("www.", "")
                    .split(".")[0]
                    .toUpperCase()}{" "}
                  is a well-known and trusted tool.
                  <br />
                  &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;
                </p>
                <h3>
                  Question: How do I place a bet on{" "}
                  {location.pathname.includes("horse-racing")
                    ? "horse"
                    : "greyhound"}{" "}
                  racing at{" "}
                  {window.location.hostname
                    .replace("www.", "")
                    .split(".")[0]
                    .toUpperCase()}
                  ?
                </h3>
                <p>
                  Answer: To place a bet, log in to your{" "}
                  {window.location.hostname
                    .replace("www.", "")
                    .split(".")[0]
                    .toUpperCase()}{" "}
                  account, navigate to the{" "}
                  {location.pathname.includes("horse-racing")
                    ? "horse"
                    : "greyhound"}{" "}
                  racing section, select the race you want to bet on, choose
                  your desired betting option, and confirm your wager.
                </p>
                <h3>
                  <br />
                  Question: How are the odds determined in{" "}
                  {location.pathname.includes("horse-racing")
                    ? "horse"
                    : "greyhound"}{" "}
                  racing betting?
                </h3>
                <p>
                  Answer: Odds are set based on the probability of a{" "}
                  {location.pathname.includes("horse-racing")
                    ? "horse"
                    : "greyhound"}
                  winning the race, calculated by bookmakers. The odds may
                  change leading up to the race based on betting patterns and
                  other factors.
                  <br />
                  &nbsp;
                </p>
                <h3>Question: What are the risks of betting on dog races?</h3>
                <p>
                  Answer: When you bet on anything, there is a chance that you
                  could lose money. Be smart about your bets and only risk what
                  you can afford to lose.
                  <br />
                  &nbsp;
                </p>
                <h3>
                  Question: Are their bonuses and promotions available to new
                  users?
                </h3>
                <p>
                  Answer: Yes,{" "}
                  {window.location.hostname
                    .replace("www.", "")
                    .split(".")[0]
                    .toUpperCase()}{" "}
                  offers bonuses and other deals to new users upon signing up.
                  It is known for offering great deals, so be sure to utilize
                  them.
                  <br />
                  &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;
                </p>
                <h3>
                  Question: Is{" "}
                  {location.pathname.includes("horse-racing")
                    ? "horse"
                    : "greyhound"}{" "}
                  racing betting legal on{" "}
                  {window.location.hostname
                    .replace("www.", "")
                    .split(".")[0]
                    .toUpperCase()}
                  ?
                </h3>
                <p>
                  Answer: Yes, betting on{" "}
                  {location.pathname.includes("horse-racing")
                    ? "horse"
                    : "greyhound"}{" "}
                  racing is legal on{" "}
                  {window.location.hostname
                    .replace("www.", "")
                    .split(".")[0]
                    .toUpperCase()}
                  , provided that you are of legal gambling age and located in a
                  jurisdiction where online betting is permitted.
                </p>
                <h3>
                  <br />
                  Question: How do I withdraw my winnings from{" "}
                  {location.pathname.includes("horse-racing")
                    ? "horse"
                    : "greyhound"}{" "}
                  racing bets?
                </h3>
                <p>
                  Answer: To withdraw your winnings, go to the withdrawal
                  section of your{" "}
                  {window.location.hostname
                    .replace("www.", "")
                    .split(".")[0]
                    .toUpperCase()}{" "}
                  account, select your preferred payment method, enter the
                  amount, and follow the on-screen instructions.
                </p>
              </article>
              <h3 className="hidden"></h3>
              <h4 className="hidden">
                Bet on{" "}
                {location.pathname.includes("horse-racing")
                  ? "horse"
                  : "greyhound"}{" "}
                racing with{" "}
                {window.location.hostname
                  .replace("www.", "")
                  .split(".")[0]
                  .toUpperCase()}
                . Enjoy competitive betting odds, fast payouts, and an exciting
                experience on every race.
              </h4>
            </>
          )}
        </article>
      </div>
    </div>
  );
};

export default connectRacingPage()(RacingPage);
